import React from "react"
import styled from "styled-components"
import Layout from "../components/layout/Layout"
import _find from "lodash/find"
import _filter from "lodash/filter"
import Seo from "../components/seo/Seo"
import HeroCreatePagesSection from "../sections/common/HeroCreatePagesSection"
import AboutMoverSection from "../sections/mover/AboutMoverSection"
import ReviewSection from "../sections/mover/ReviewSection"
// import ServicesSection from "../sections/mover/ServicesSection"
import AreaServedSection from "../sections/mover/AreaServedSection"
import ContactSection from "../sections/mover/ContactSection"
import OpenTimeSection from "../sections/mover/OpenTimeSection"
import AwardsSection from "../sections/mover/AwardsSection"

const Mover = context => {
  const currentCity = () => {
    return _find(context.pageContext.mover.states, [
      "city_slug",
      context.pageContext.state.city_slug,
    ])
  }

  const areasServed = () => {
    return _filter(context.pageContext.mover.states, item => {
      return item.city_slug !== currentCity().city_slug
    })
  }

  const seoTitle = `${context.pageContext.mover.name} Reviews & Rating | Top Movers in ${context.pageContext.mover.states[0].name}`
  const seoDescription = `${context.pageContext.mover.name} service reviews & rating, professional moving services overview as one of the top moving companies in ${context.pageContext.mover.states[0].name}. Contact for an estimate.`

  return (
    <Layout>
      <Seo title={seoTitle} description={seoDescription} />
      <HeroCreatePagesSection
        titleDescription="Moving Company"
        name={context.pageContext.mover.name}
      />
      <Wrapper>
        <AboutMoverSection
          logo={context.pageContext.mover.publicLogoUrl}
          name={context.pageContext.mover.name}
          description={context.pageContext.mover.description}
        />
        <ReviewSection
          description={context.pageContext.mover.review_description}
          google_average_review={
            context.pageContext.mover.google_average_review
          }
          yelp_average_review={context.pageContext.mover.yelp_average_review}
          bbb_rating={context.pageContext.mover.bbb_rating}
        />
        {/*{context.pageContext.mover.services.length ? (*/}
        {/*  <ServicesSection*/}
        {/*    name={context.pageContext.mover.name}*/}
        {/*    services={context.pageContext.mover.services}*/}
        {/*    website={context.pageContext.mover.website}*/}
        {/*  />*/}
        {/*) : null}*/}

        {context.pageContext.mover.awards.length ? (
          <AwardsSection
            awards={context.pageContext.mover.awards}
            mover={context.pageContext.mover}
          />
        ) : null}

        {areasServed().length ? (
          <AreaServedSection areas={areasServed()} />
        ) : null}
        {context.pageContext.mover.open_time && (
          <OpenTimeSection open_time={context.pageContext.mover.open_time} />
        )}
        <ContactSection
          facebook_url={context.pageContext.mover.facebook_url}
          bbb_url={context.pageContext.mover.bbb_url}
          angieslist_url={context.pageContext.mover.angieslist_url}
          google_page_url={context.pageContext.mover.google_page_url}
          yellow_pages_url={context.pageContext.mover.yellow_pages_url}
          yelp_url={context.pageContext.mover.yelp_url}
          address={context.pageContext.mover.address}
          city={context.pageContext.mover.city}
          state={context.pageContext.mover.state}
          open_time={context.pageContext.mover.open_time}
          phone={context.pageContext.mover.phone}
          website={context.pageContext.mover.website}
          lat={context.pageContext.mover.latitude}
          lon={context.pageContext.mover.longitude}
        />
      </Wrapper>
    </Layout>
  )
}

export default Mover

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #ffffff 0%, #ecf2fa 50%, #ffffff 100%);
`
